import { useContext, useState, memo } from "react";
import File from "./File";
import { BrowserContext } from "../services/BrowserContext";

const Image = (props)=>{
    const {handleCarouselActiveFileName, itemsManipulator} = useContext(BrowserContext);
    const [thumbError, setThumbError] = useState(false);

    const displayCarousel = function() {
        handleCarouselActiveFileName(props.name);
    }

    // URL signée (le session_id n'apparaît plus dans l'URL).
    const src = itemsManipulator.signedDownloadUrl(props.path, props.name, props.dlExp, props.dlSig);

    return <File onDoubleClick={displayCarousel} {...props}><File.Ico>
        {thumbError
            ? <i className="bi bi-file-earmark-image fs-4 me-1"></i>
            : <img src={src} alt={props.name} onError={() => setThumbError(true)} style={{width:'32px', height:'32px', objectFit:'cover', borderRadius:'4px', marginRight:'5px'}}/>
        }
    </File.Ico></File>
}

export default memo(Image)